import React, { useEffect } from 'react'
import { Route, useLocation, useNavigate } from 'react-router-dom';
import AttendanceHRIndex from '../Views/Web/HR/Attendance/AttendanceIndex';
import MainHr from '../Views/Web/HR/MainHr';
import MainTimesheetsHR from '../Views/Web/HR/Timesheets/MainTimesheets';
import TimesheetsHRIndex from '../Views/Web/HR/Timesheets/TimesheetsIndex';
import MainHRTeam from '../Views/Web/HR/Team/MainTeam';
import HRIndex from '../Views/Web/HR/Team/Index';
import { Wrapper } from '../Components/Utils/roles';
import MainHRAttendance from '../Views/Web/HR/Attendance/MainAttendance';
import HRTeamIndex from '../Views/Web/HR/Team/Index';
import AddHRTeam from '../Views/Web/HR/Team/AddTeam';
import ExitHRTeam from '../Views/Web/HR/Team/ExitTeam';
import ViewHRTeam from '../Views/Web/HR/Team/ViewTeam';

function HrRoutes() {
    const location = useLocation();
      const navigate = useNavigate();
    
      useEffect(() => {
        if (
          location.pathname === "/hr" ||
          location.pathname === "/hr/") {
          navigate("/page-not-found")
        }
      },[location])
   return (
      <Route path="hr" element={<MainHr />}>
        <Route path="attendance" element={<MainHRAttendance />}>
          <Route index element={<Wrapper accessKey={"attendance_view"}  Component={AttendanceHRIndex} />} />
          {/* <Route path="create" element={<NoteCreate />} />
          <Route path="edit/:attendanceEditId" element={<NoteEdit />} />
          <Route path="view/:attendanceViewId" element={<NotesView />} /> */}
        </Route>
        <Route path="timesheets" element={<MainTimesheetsHR />}>
          <Route index element={<Wrapper accessKey={"timesheets_view"}  Component={TimesheetsHRIndex} />} />
        </Route>
        <Route path="team" element={<MainHRTeam />}>
          <Route index element={<Wrapper accessKey={"team_view"}  Component={HRTeamIndex} />} />
          <Route path="create" element={<AddHRTeam />} />
                   {/* <Route path="edit/:receivedEditId" element={<ExitTeam />} />
                   <Route path="view/:receivedViewId" element={<ViewTeam />} /> */}
                   <Route path="edit" element={<ExitHRTeam />} />
                   <Route path="view" element={<ViewHRTeam />} />    </Route>
      </Route>
    );
}

export default HrRoutes